var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tabs',[_vm._l((_vm.games),function(game){return _c('v-tab',{key:game.title},[_vm._v(_vm._s(game.title))])}),_c('v-tab',[_vm._v("Dictionary")]),_vm._l((_vm.games),function(game){return _c('v-tab-item',{key:game.id},[_c('list-game',{attrs:{"game":game}})],1)}),_c('v-tab-item',[_c('list-dictionary')],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }